import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Programs from "./pages/Programs";
import CouncilMembers from "./pages/CouncilMembers";
import Membership from "./pages/Membership";
import Events from "./pages/Events";
import EventDetail from "./pages/EventDetail";
import Contact from "./pages/Contact";

function App() {
	return (
		<Router>
			<div className="min-h-screen flex flex-col">
				<Navbar />
				<main className="flex-grow">
					<Routes>
						<Route path="/" element={<Home />} />
						<Route path="/about" element={<About />} />
						<Route path="/programs" element={<Programs />} />
						<Route path="/council-members" element={<CouncilMembers />} />
						<Route path="/membership" element={<Membership />} />
						<Route path="/events" element={<Events />} />
						<Route path="/event/:slug" element={<EventDetail />} />
						<Route path="/contact" element={<Contact />} />
					</Routes>
				</main>
				<Footer />
			</div>
		</Router>
	);
}

export default App;
